import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";

// Styled DateTimePicker mirroring the InputDate wrapper — used where both date
// and time precision matter (e.g. coupon schedules, flash sales).
const InputDateTime = (props) => {
  const {
    label,
    variant = "outlined",
    size,
    name,
    value,
    onChange,
    error,
    minDateTime,
    maxDateTime,
    fullWidth = true,
    required = false,
    ampm = true,
    views = ["day", "hours", "minutes"],
    openTo = "day",
    ...other
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={label}
        name={name}
        value={(value && dayjs(value)) || null}
        onChange={onChange}
        views={views}
        openTo={openTo}
        format="DD MMM, YYYY hh:mm A"
        ampm={ampm}
        minDateTime={(minDateTime && dayjs(minDateTime)) || null}
        maxDateTime={(maxDateTime && dayjs(maxDateTime)) || null}
        slotProps={{
          textField: {
            variant: variant,
            size: size || "small",
            fullWidth: fullWidth,
            ...other,
            ...(error && { error: true, helperText: error }),
            required: required,
            placeholder: "DD Mon YYYY HH:MM",
          },
          desktopPaper: {
            style: {
              backgroundColor: "var(--white-color)",
              boxShadow: "none",
              border: "1px solid var(--primaryMD-color)",
            },
          },
          mobilePaper: {
            style: {
              backgroundColor: "var(--white-color)",
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default InputDateTime;
